import axios from '../lib/axios'
import Bugsnag from './Bugsnag'
import AuthenticationService from '../services/AuthenticationService'

export default {
  hasMetabaseId () {
    const metabaseId = localStorage.getItem('metabase_id')
    return metabaseId && metabaseId !== 'undefined' && metabaseId !== 'null'
  },

  async askToCreateMetabaseAccount (toast) {
    if (confirm("To access advanced reports, you'll need to set up a reporting login. We’ll send you an email with quick instructions to get started. Would you like to continue?")) {
      await axios({
        method: 'POST',
        url: process.env.METABASE_LAMBDA_URL,
        headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
        data: {
          email: localStorage.getItem('email'),
          name: localStorage.getItem('name'),
          family_name: localStorage.getItem('family_name'),
          username: localStorage.getItem('username')
        }
      }).then(response => {
        localStorage.setItem('metabase_id', response.data.metabase_id)
      }).catch(error => {
        Bugsnag.send(error)
      }).finally(() => {
        toast.success("An invitation email to join Zlick's advanced reports has been sent to your email address")
      })
    }
  },

  async deleteMetabaseAccount (metabaseId, groupName) {
    if (!AuthenticationService.isInRole(['admin'])) throw new Error('Permission denied.')

    await axios({
      method: 'DELETE',
      url: process.env.METABASE_LAMBDA_URL + '/' + metabaseId,
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
      data: {
        group_name: groupName
      }
    })
  },

  async addUserToMetabaseGroup (metabaseId, groupName) {
    if (!AuthenticationService.isInRole(['admin'])) throw new Error('Permission denied.')

    await axios({
      method: 'POST',
      url: process.env.METABASE_LAMBDA_URL + '/add-to-group',
      headers: { 'Authorization': 'Bearer ' + localStorage.getItem('token') },
      data: {
        metabase_id: metabaseId,
        group_name: groupName
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/services/CognitoService.js